import { parsePhoneNumber } from 'libphonenumber-js/min'

export function formatPhoneDisplay(phone: string | null | undefined): string {
  if (!phone) return ''
  try {
    const parsed = parsePhoneNumber(phone, 'US')
    return parsed.country === 'US' ? parsed.formatNational() : parsed.formatInternational()
  } catch {
    return phone
  }
}
